/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_Position_DescInputs */

const en_ui_studio_marker_position_desc = /** @type {(inputs: Ui_Studio_Marker_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set where this sits along the route, measured from the start.`)
};

const de_ui_studio_marker_position_desc = /** @type {(inputs: Ui_Studio_Marker_Position_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lege fest, wo der Punkt auf der Route liegt — gemessen ab dem Start.`)
};

/**
* | output |
* | --- |
* | "Set where this sits along the route, measured from the start." |
*
* @param {Ui_Studio_Marker_Position_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_position_desc = /** @type {((inputs?: Ui_Studio_Marker_Position_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_Position_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_position_desc(inputs)
	return de_ui_studio_marker_position_desc(inputs)
});